import { Component, EventEmitter, Input, Output } from "@angular/core";

import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Component({
  selector: "myp-list-item",
  templateUrl: "list-item.component.html",
})
export class ListItemComponent extends BaseComponent {
  @Input() item: any;
  @Input() showImage: boolean = true;
  @Input() photo: string;
  @Input() icon: string;
  @Input() title: string;
  @Input() imageRound: boolean = true;
  @Input() imageBorder: boolean = true;
  @Input() largeImage: boolean = false;
  @Input() subData: Array<string>;
  @Input() includeChevron: boolean = true;
  @Input() inactive: boolean;
  @Output() itemClicked: EventEmitter<any> = new EventEmitter();

  constructor(userService: UserService) {
    super(userService);
  }

  itemClick(event) {
    this.itemClicked.next(this.item);
  }
}
